var cifSo = ["300 200", "<g fill='none'><path fill='#4189DD' d='M0 0h300v200H0z'/><path fill='#FFF' d='M104.208 85.122l28.301 20.561-10.81 33.27L150 118.391l28.301 20.562-10.81-33.27 28.301-20.561H160.81L150 51.852l-10.81 33.27z'/></g>"];

export { cifSo };

